import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import SlackLandingHelmet from 'common/helmets/SlackLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';
import Slack1 from 'img/landing/slack-1.webp';
import Slack2 from 'img/landing/slack-2.webp';
import Slack3 from 'img/landing/slack-3.webp';

import SlackLogo from 'img/canny-slack-integration.png';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

class SlackLanding extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Slack Integration Page');
  }

  render() {
    return (
      <div className="integrationsLanding">
        <SlackLandingHelmet />
        <div className="integrationsLandingContainer">
          <div className="header">
            <div className="left">
              <LazyLoadedImage className="appLogo" loading="eager" src={SlackLogo} />
              <div className="text">
                <h1 className="title">Canny for Slack</h1>
                <div className="subtitle">Capture and subscribe to feedback in&nbsp;Slack</div>
                <div className="links">
                  <InstallExtensionButton
                    installButtonText="Get started"
                    installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fslack"
                  />

                  <a
                    href="http://help.canny.io/en/articles/766734-slack-integration"
                    rel="noopener"
                    target="_blank"
                    className="LandingIntegrations__install-link">
                    See install docs
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="features">
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" loading="eager" src={Slack1} />
              </div>
              <div className="featureText">
                <div className="title">Keep your team up to date on user&nbsp;feedback</div>
                <div className="subtitle">
                  Specify which boards and events you want to receive notifications&nbsp;for.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={Slack2} />
              </div>
              <div className="featureText">
                <div className="title">Add votes from within&nbsp;Slack</div>
                <div className="subtitle">Keep track of who the feedback is coming&nbsp;from.</div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={Slack3} />
              </div>
              <div className="featureText">
                <div className="title">New feedback? Create a new&nbsp;post</div>
                <div className="subtitle">
                  This integration is great for when your team has product conversations
                  in&nbsp;Slack.
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default compose(
  withContexts({
    trackEvent: TrackEventContext,
    viewer: ViewerContext,
  }),
  hot,
)(SlackLanding);
